module.exports = __webpack_public_path__ + "img/goosenecks.0ad1bf98.png";